import React from 'react';
import Brands from '../components/Brands';
import Sections from '../components/Sections';
import TopSection from '../components/TopSection';
import DashboardImg1 from '../assets/images/dashboard-1.png';
import DashboardImg2 from '../assets/images/dashboard-2.png';

const contents = {
  title: 'Building a content repository has never been easy',
  description:
    'TheDocPro saves pharmaceuticals the hassle of setting up and maintaining an online content infrastructure. Since the platform is loaded with state-of-the art features, your team can focus marketing and engagement, while we handle the technical side!',
  points: [
    { title: 'Conduct engaging webinars, and let your doctors access a repository of archived webinars' },
    { title: 'Promote your products and recent launches by position engaging ads across the platform' },
    { title: 'White-labelled platform with class-leading support and 99.99% uptime' },
  ],
};

const contents2 = {
  title: 'About time you get broader and deeper insights',
  description: 'You get a dashboard to track the performance of your content and the engagement of the doctors on the platform, for each webinar, video, or ad on the platform.',
  points: [
    { title: 'Detailed insights on activity of the doctors on the platform, and their progress' },
    { title: 'Enables tracking of ad views, ad clicks, and several other parameters to optimize campaigns and engagement' },
    { title: 'Consolidated view of user feedbacks across the platform' },
  ],
};

function Home() {
  return (
    <div>
      <TopSection />
      <Brands />
      <div id='features' style={{ transitionDuration: '1000ms' }}>
        <Sections title={contents.title} description={contents.description} points={contents.points} media={DashboardImg1} className='contentsBg' showUptillText={true} />
      </div>
      <Sections title={contents2.title} description={contents2.description} points={contents2.points} media={DashboardImg2} showUptillText={false} />
    </div>
  );
}

export default Home;
